import {Dialog, DialogActionsBar} from "@progress/kendo-react-dialogs";
import {Button} from "@progress/kendo-react-buttons";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import {TabStrip, TabStripTab} from "@progress/kendo-react-layout";
import "./IdxTagInstructions.css";
import {button} from "../../helpers/ActivateSegmentFormHelpers";
import siteVisitorTagImg from '../images/SiteTagWithoutDevice.png';

const IdxTagInstructions = (props) => {

    const {pixelTagId, setShowTagCode, pixelTagObj} = props;
    const loggedInFromToolbox = sessionStorage.getItem("isToolboxLogged");
    const [selectedTab, setSelectedTab] = useState(0);
    const [copyState, setCopyState] = useState({
        siteHref: false,
        siteGtm: false,
        categoryImage: false,
        category: false
    });
    const siteSnippet = useMemo(() => buildSiteTagSnippet(pixelTagId, "window.location.href"), [pixelTagId]);
    const siteGtmSnippet = useMemo(() => buildSiteTagSnippet(pixelTagId, "{{Page URL}}"), [pixelTagId]);
    const categorySnippet = useMemo(() => buildCategoryTagSnippet(pixelTagId), [pixelTagId]);
    const categoryImageSnippet = useMemo(() => buildCategoryImageTagSnippet(pixelTagId), [pixelTagId]);

    const handleCopy = useCallback(async (key, text) => {
        if (!pixelTagId) return;
        const ok = await copyText(text);
        setCopyState(s => ({...s, [key]: ok ? 'copied' : 'failed'}));
        setTimeout(() => setCopyState(s => ({...s, [key]: false})), 2000);
    }, [pixelTagId]);
    const handleSelectTab = e => {
        console.log(e)
        setSelectedTab(e.selected);
    };
    const closePixelDialog = () => {
        setShowTagCode(false);
    }


    function copyCategoryTag() {
        if (pixelTagId !== undefined) {
            document.getElementById("category-copy-button").innerHTML = "Copied!"
            return navigator.clipboard.writeText(buildCategoryTagSnippet(pixelTagId));
        } else {
            document.getElementById("category-copy-button2").innerHTML = "Not Available"
            return navigator.clipboard.writeText("Not Available");
        }

    }

    // --- small util to copy text safely
    async function copyText(text) {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch {
            try {
                const ta = document.createElement("textarea");
                ta.value = text;
                ta.setAttribute("readonly", "");
                ta.style.position = "absolute";
                ta.style.left = "-9999px";
                document.body.appendChild(ta);
                ta.select();
                document.execCommand("copy");
                document.body.removeChild(ta);
                return true;
            } catch {
                return false;
            }
        }
    }

    function buildSiteTagSnippet(pixelTagId, pageUrlSource) {
        return `
<script>
(function () {
  var pageUrl = encodeURIComponent(${pageUrlSource});
        var img = document.createElement("img");
        img.id = "idx-tag";
        img.alt = "";
        img.style.display = "none";
        img.src = "https://idxgm.rtactivate.com/tagid/${pixelTagId}/?url=" + pageUrl;
        document.body.appendChild(img);
})();
</script>`;
    }

    function buildCategoryTagSnippet(pixelTagId) {
        return `
<script>
(function () {
        var img = document.createElement("img");
        img.id = "idx-tag";
        img.alt = "";
        img.style.display = "none";
        img.src = "https://idxgm.rtactivate.com/tagid/${pixelTagId}/?" +
                  "category1=" + ${"${CATEGORY1}"} +
                  "&category2=" + ${"${CATEGORY2}"} +
                  "&category3=" + ${"${CATEGORY3}"};
        document.body.appendChild(img);
})();
</script>`;
    }

    function buildCategoryImageTagSnippet(pixelTagId) {
        return `<img id="idx-tag" src="https://idxgm.rtactivate.com/tagid/${pixelTagId}/?category1=${"${CATEGORY1}"}&category2=${"${CATEGORY2}"}&category3=${"${CATEGORY3}"}" alt="" style="display:none !important;" />`;
    }

    useEffect(() => {
        console.log(selectedTab)
    }, [selectedTab]);
    return (
        <div>
            <Dialog
                className={"idx-pixel-dialog dialog-standard"}
                title={"IDX Tag"}
                closeIcon={false}
                width={"55vw"}
                height={"80vh"}
            >
                {/*<div className={"pixel-dialog-text-container"}>*/}
                <TabStrip selected={selectedTab} onSelect={handleSelectTab} tabPosition={"top"} renderAllContent={true}>

                    {pixelTagObj.segment_naming_type === "CATEGORY" &&
                        <TabStripTab title="Category Tag" className={"category-tab"}>
                            <div className={"paragraph-standard"}>
                                <span>A category tag will allow a client to add Macros which will provide data points on a dynamic basis. These categories will allow a user to have up to 3 more data points to segment the results by.  Examples of when to use Category Tags.                                <strong>Important!: Please remember that a category tag that creates segments should always be regarded as a collection point for matched membership, never as a unique value for every tag fired.
                                       To do that include id=value in the query string. Note: Your tag will not be included in processing when this uniqueness condition is detected.</strong></span>
                            </div>
                            <ul>
                                <li>
                                    AdServer
                                </li>
                                <li>
                                    eCommerce Website
                                </li>
                                <li>
                                    SSP Platform
                                </li>
                            </ul>

                            <div className={"sub-title"}>Image Tag</div>
                            <div className={"script-wrapper"}>
                                <div className={"script-block"}>
                                    <pre>
                                        <code>
                                            {`<img id="idx-tag" src="https://idxgm.rtactivate.com/tagid/`}<strong>{pixelTagId}</strong>{`/?category1=${"${CATEGORY1}"}&category2=${"${CATEGORY2}"}&category3=${"${CATEGORY3}"}" alt="" style="display:none !important;" />

`}
                                        </code>
                                    </pre>
                                </div>
                            </div>
                            <Button className={"btn btn-primary"} onClick={() => handleCopy('categoryImage', categoryImageSnippet)}>
                                {copyState.categoryImage === 'copied' ? 'Copied!' :
                                    copyState.categoryImage === 'failed' ? 'Copy failed' : 'Copy'}
                            </Button>
                            <div className={"paragraph-standard"}></div>
                            <div className={"sub-title"}>Script Tag</div>
                            <div className={"script-wrapper"}>
                                <div className={"script-block"}>
                                    <pre><code>{categorySnippet}</code></pre>
                                    <pre style={{display: "none"}}>
  <code>
    {`<img id="idx-tag" src="https://idxgm.rtactivate.com/tagid/`}<strong>{pixelTagId}</strong>{`/?category1=${"${CATEGORY1}"}&category2=${"${CATEGORY2}"}&category3=${"${CATEGORY3}"}" alt="" style="display:none !important;" />
<script src="https://cdn.jsdelivr.net/npm/ua-parser-js@1.0.39/src/ua-parser.min.js"></script>
<script src="https://cdn.jsdelivr.net/npm/blueimp-md5/js/md5.min.js"></script>
<script>
(function () {
  function toUuidFromHex(hex) {
    return (
      hex.slice(0, 8) + "-" +
      hex.slice(8, 12) + "-" +
      hex.slice(12, 16) + "-" +
      hex.slice(16, 20) + "-" +
      hex.slice(20, 32)
    );
  }

  function deterministicUuidLikeFromMd5(input) {
    var hex = md5(input);
    var chars = hex.split("");
    chars[12] = "4";
    var v = parseInt(chars[16], 16);
    chars[16] = ((v & 0x3) | 0x8).toString(16);
    return toUuidFromHex(chars.join(""));
  }

  function run() {
    var el = document.getElementById("idx-tag");
    if (!el) return;

    var parser = new UAParser(window.navigator.userAgent);
    var parsed = parser.getResult();

    var deviceType = (parsed.device && parsed.device.type) ? parsed.device.type : "desktop";
    var deviceModel = (parsed.device && parsed.device.model) ? parsed.device.model : "unknown";
    var osName = (parsed.os && parsed.os.name) ? parsed.os.name : "unknown";
    var browserName = (parsed.browser && parsed.browser.name) ? parsed.browser.name : "unknown";
    var osVersion = (parsed.os && parsed.os.version) ? parsed.os.version : "unknown";
    var screenWidth = (window.screen && window.screen.width) ? window.screen.width : "unknown";
    var screenHeight = (window.screen && window.screen.height) ? window.screen.height : "unknown";
    var logicalProcessors = navigator.hardwareConcurrency ? navigator.hardwareConcurrency : "unknown";
    var navDeviceMemory = navigator.deviceMemory ? navigator.deviceMemory : "unknown";

    var inputString =
      deviceType + "_" + deviceModel + "_" + osName + "_" + browserName + "_" +
      osVersion + "_" + screenWidth + "x" + screenHeight + "_" +
      logicalProcessors + "_" + navDeviceMemory;

    var deviceUuid = deterministicUuidLikeFromMd5(inputString);

    try {
      var u = new URL(el.src);
      u.searchParams.set("device", deviceUuid);
      el.src = u.toString();
    } catch (e) {
      if (el.src.indexOf("/?") !== -1) {
        el.src = el.src.replace("?", "?device=" + deviceUuid + "&");
      } else {
        el.src += "&device=" + deviceUuid;
      }
    }

  }

  try {
    run();
  } catch (err) {
    console.error("IDX category tag generation failed:", err);
  }
})();
</script>`}
  </code>
</pre>
                                </div>
                            </div>
                            <Button className={"btn btn-primary"} onClick={() => handleCopy('category', categorySnippet)}>
                                {copyState.category === 'copied' ? 'Copied!' :
                                    copyState.category === 'failed' ? 'Copy failed' : 'Copy'}
                            </Button>
                            <div className={"paragraph-standard"}>
                                <div className={"sub-title"}>Customize the IDX Pixel Tag for Your Needs</div>
                                <div>Adjust the pixel code as necessary to capture specific data points, such as user
                                    interactions, page
                                    views, or conversions.
                                </div>
                                <ul>
                                    <li>
                                        Replace the placeholders ${"{CATEGORY1}"}, ${"{CATEGORY2}"}, and
                                        ${"{CATEGORY3}"} with
                                        the
                                        relevant parameters from your system. These parameters should be dynamically
                                        generated based on the specific context of the platform you are using.
                                    </li>
                                </ul>
                                <div>
                                    The replacements can be as follows:
                                </div>
                                <ul>
                                    <li>
                                        <strong>Client_ID</strong>: Replace Client_ID with your ID (or leave blank).
                                    </li>
                                    <li>
                                        <strong>Category1</strong>: Identifier that you would use to create a custom
                                        segment.
                                    </li>
                                    <li>
                                        <strong>Category2</strong>: Identifier that you would use to create a custom
                                        segment.
                                    </li>
                                    <li>
                                        <strong>Category3</strong>: Identifier that you would use to create a custom
                                        segment.
                                    </li>
                                </ul>
                                <div className={"mb-1"}>
                                    If there are no parameters or macros to capture, replace Category1 with Brand Name
                                </div>
                                <div>
                                    To ensure the URL is correctly formatted, you need to urlencode the values of the
                                    parameters.
                                    urlencode replaces spaces and special characters with their corresponding
                                    percent-encoded
                                    values.
                                </div>
                            </div>
                            <div className={"paragraph-standard"}>
                                <div className={"sub-title"}>Ad Server Example</div>
                                <div>
                                    <ul>
                                        <li>
                                            <strong>id</strong> – The ID can be a unique ID provided by the client or it
                                            can
                                            be used to
                                            include other
                                            details. In this example we will inlcude
                                            ${"{CAMPAIGN_ID}"}-${"{CACHEBUSTER}"} (Add
                                            any
                                            additional macros separated by a dash -).
                                        </li>
                                        <li>
                                            <strong>category1</strong> – Replace with the Placement ID (e.g.,
                                            ${"{PLACEMENT_ID}"}).
                                        </li>
                                        <li>
                                            <strong>category2</strong> – Replace with the Creative ID (e.g.,
                                            ${"{CREATIVE_ID}"}).
                                        </li>
                                        <li>
                                            <strong>category3</strong> – Replace with the Encoded Click URL (e.g.,
                                            ${"{CLICK_URL_ENC}"}).
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className={"paragraph-standard"}>
                                <div className={"sub-title"}>eCommerce Website Example</div>
                                <div className={"mb-1"}>
                                    Replace the placeholders with the relevant parameters from your system. These
                                    parameters should be dynamically generated based on your platform's context:
                                </div>
                                <div>
                                    Example URL Format Retailer:
                                </div>
                                <ul>
                                    <li>
                                        <strong>Category1</strong> = Brand (GAP, OLD_NAVY, BANANA_ REPUBLIC, ATHLETA)
                                    </li>
                                    <li>
                                        <strong>Category2</strong> = Section (NEW, WOMEN, MEN, GIRLS, BOYS, SALE)
                                    </li>
                                    <li>
                                        <strong>Category3</strong> = Product (JEANS, PANTS, DRESSES, ETC)
                                    </li>
                                </ul>
                            </div>

                        </TabStripTab>}
                    {pixelTagObj.segment_naming_type !== "CATEGORY" &&
                        <TabStripTab title="Site Tag" className={"impression-tracker-tab"}>
                            <div>
                                <span className={"sub-title"}>Place Tag on the Website</span>
                                <div>You can implement the impression tag either sitewide or on selected pages: Below
                                    are
                                    step-by-step instructions for implementing an impression tag directly on a website
                                    or
                                    using Google Tag Manager (GTM).
                                </div>
                                <div className={"paragraph-standard"}>
                                    <strong>Important!: Please remember that a site tag that create segments should always be regarded as a collection point for matched membership, never as a unique value for every tag fired.
                                         To do that include id=value in the query string and NOT AS PART OF THE URL proper. Note: Your tag will not be included in processing when this uniqueness condition is detected.</strong>
                                </div>

                                <div className={"paragraph-standard"}>
                                    <strong>{`IDX Site Tag:`}</strong>
                                    <div className={"script-wrapper"}>
                                        <div className={"script-block"}>
                                            <pre><code>{siteSnippet}</code></pre>
                                            <pre style={{display: "none"}}>
<code>
    {`<script src="https://cdn.jsdelivr.net/npm/ua-parser-js@1.0.39/src/ua-parser.min.js"></script>
<script src="https://cdn.jsdelivr.net/npm/blueimp-md5/js/md5.min.js"></script>
<script>
(function () {
    function toUuidFromHex(hex) {
        return (
            hex.slice(0, 8) + "-" +
            hex.slice(8, 12) + "-" +
            hex.slice(12, 16) + "-" +
            hex.slice(16, 20) + "-" +
            hex.slice(20, 32)
        );
    }

    function deterministicUuidLikeFromMd5(input) {
        var hex = md5(input);
        var chars = hex.split("");
        chars[12] = "4";
        var v = parseInt(chars[16], 16);
        chars[16] = ((v & 0x3) | 0x8).toString(16);
        return toUuidFromHex(chars.join(""));
    }

    function run() {
        var parser = new UAParser(window.navigator.userAgent);
        var parsed = parser.getResult();

        var deviceType = (parsed.device && parsed.device.type) ? parsed.device.type : "desktop";
        var deviceModel = (parsed.device && parsed.device.model) ? parsed.device.model : "unknown";
        var osName = (parsed.os && parsed.os.name) ? parsed.os.name : "unknown";
        var browserName = (parsed.browser && parsed.browser.name) ? parsed.browser.name : "unknown";
        var osVersion = (parsed.os && parsed.os.version) ? parsed.os.version : "unknown";
        var screenWidth = (window.screen && window.screen.width) ? window.screen.width : "unknown";
        var screenHeight = (window.screen && window.screen.height) ? window.screen.height : "unknown";
        var logicalProcessors = navigator.hardwareConcurrency ? navigator.hardwareConcurrency : "unknown";
        var navDeviceMemory = navigator.deviceMemory ? navigator.deviceMemory : "unknown";

        var inputString =
            deviceType + "_" + deviceModel + "_" + osName + "_" + browserName + "_" +
            osVersion + "_" + screenWidth + "x" + screenHeight + "_" +
            logicalProcessors + "_" + navDeviceMemory;

        var deviceUuid = deterministicUuidLikeFromMd5(inputString);

        var parts = [];
        parts.push("device=" + deviceUuid);
        parts.push("url=" + encodeURIComponent(window.location.href));

    var img = document.createElement("img");
    img.id = "idx-tag";
    img.alt = "";
    img.style.display = "none";
    img.src = "https://idxgm.rtactivate.com/tagid/`}
    <strong>{pixelTagId}</strong>
    {`/?" + parts.join("&");

    document.body.appendChild(img);
    }

    try {
        run();
    } catch (err) {
        console.error("IDX tag generation failed:", err);
    }
})();
</script>`}
  </code>
</pre>
                                        </div>
                                    </div>
                                    <Button className={"btn btn-primary"} onClick={() => handleCopy('siteHref', siteSnippet)}>
                                        {copyState.siteHref === 'copied' ? 'Copied!' :
                                            copyState.siteHref === 'failed' ? 'Copy failed' : 'Copy'}
                                    </Button>
                                </div>
                                <div className={"paragraph-standard"}>
                                    <strong>{`IDX Site Tag (for Google Tag Manager and pre-defined Variables):`}</strong>
                                    <div className={"script-wrapper"}>
                                        <div className={"script-block"}>
                                            <pre><code>{siteGtmSnippet}</code></pre>
                                            <pre style={{display: "none"}}>
<code>
    {`<script src="https://cdn.jsdelivr.net/npm/ua-parser-js@1.0.39/src/ua-parser.min.js"></script>
<script src="https://cdn.jsdelivr.net/npm/blueimp-md5/js/md5.min.js"></script>
<script>
(function () {
    function toUuidFromHex(hex) {
        return (
            hex.slice(0, 8) + "-" +
            hex.slice(8, 12) + "-" +
            hex.slice(12, 16) + "-" +
            hex.slice(16, 20) + "-" +
            hex.slice(20, 32)
        );
    }

    function deterministicUuidLikeFromMd5(input) {
        var hex = md5(input);
        var chars = hex.split("");
        chars[12] = "4";
        var v = parseInt(chars[16], 16);
        chars[16] = ((v & 0x3) | 0x8).toString(16);
        return toUuidFromHex(chars.join(""));
    }

    function run() {
        var parser = new UAParser(window.navigator.userAgent);
        var parsed = parser.getResult();

        var deviceType = (parsed.device && parsed.device.type) ? parsed.device.type : "desktop";
        var deviceModel = (parsed.device && parsed.device.model) ? parsed.device.model : "unknown";
        var osName = (parsed.os && parsed.os.name) ? parsed.os.name : "unknown";
        var browserName = (parsed.browser && parsed.browser.name) ? parsed.browser.name: "unknown";
        var osVersion = (parsed.os && parsed.os.version) ? parsed.os.version : "unknown";
        var screenWidth = (window.screen && window.screen.width) ? window.screen.width : "unknown";
        var screenHeight = (window.screen && window.screen.height) ?  window.screen.height : "unknown";
        var logicalProcessors = navigator.hardwareConcurrency ?  navigator.hardwareConcurrency : "unknown";
        var navDeviceMemory = navigator.deviceMemory ? navigator.deviceMemory : "unknown";

        var inputString =
            deviceType + "_" + deviceModel + "_" + osName + "_" + browserName + "_" +
            osVersion + "_" + screenWidth + "x" + screenHeight + "_" +
            logicalProcessors + "_" + navDeviceMemory;

        var deviceUuid = deterministicUuidLikeFromMd5(inputString);

        var parts = [];
        parts.push("device=" + deviceUuid);
        parts.push("url=" + encodeURIComponent({{Page URL}}));

    var img = document.createElement("img");
    img.id = "idx-tag";
    img.alt = "";
    img.style.display = "none";
    img.src = "https://idxgm.rtactivate.com/tagid/`}
    <strong>{pixelTagId}</strong>
    {`/?" + parts.join("&");

    document.body.appendChild(img);
    }

    try {
        run();
    } catch (err) {
        console.error("IDX tag generation failed:", err);
    }
})();
</script>`}
  </code>
</pre>
                                        </div>
                                    </div>
                                    <Button className={"btn btn-primary"} onClick={() => handleCopy('siteGtm', siteGtmSnippet)}>
                                        {copyState.siteGtm === 'copied' ? 'Copied!' :
                                            copyState.siteGtm === 'failed' ? 'Copy failed' : 'Copy'}
                                    </Button>
                                </div>
                                <div className={"paragraph-standard"}>
                                    <strong>{`Website:`}</strong>
                                    <div>
                                        &nbsp;&nbsp;&nbsp;&nbsp;

                                        <ul>
                                            <li>
                                                {"Navigate to the section of the website where the tag should be triggered (e.g., the \<head\> section for sitewide tracking or specific pages for page-level tracking)."}
                                            </li>
                                            <li>
                                                Paste the impression tag code into the HTML
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className={"paragraph-standard"}>
                                    <strong>{`Google Tag Manager:`}</strong>
                                    <div>
                                        &nbsp;&nbsp;&nbsp;&nbsp;

                                        <ul>
                                            <li>
                                                Create a New Tag:
                                                <ul>
                                                    <li>
                                                        Click on Tags in the GTM dashboard and then New.
                                                    </li>
                                                    <li>
                                                        Select Custom HTML as the tag type.
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                Add the Impression Tag Code:
                                                <ul>
                                                    <li>
                                                        Paste the impression tag code (provided by your analytics or ad
                                                        platform) into the HTML field.
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                Set the Trigger:
                                                <ul>
                                                    <li>
                                                        Click Triggering and select where the tag should fire:
                                                        <ul>
                                                            <li>
                                                                For sitewide tracking, select All Pages.
                                                            </li>
                                                            <li>
                                                                For specific pages, create a Page View Trigger and
                                                                define
                                                                the page URL or conditions.
                                                            </li>
                                                        </ul>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                Save the Tag:
                                                <ul>
                                                    <li>
                                                        Name the tag (e.g., "Impression Tag") and click Save.
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                Publish the Changes:
                                                <ul>
                                                    <li>
                                                        In the GTM dashboard, click Submit to publish your changes.
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                Test the Tag:
                                                <ul>
                                                    <li>
                                                        Use GTM's Preview Mode to ensure the tag is firing correctly on
                                                        the
                                                        intended pages.
                                                    </li>
                                                    <li>
                                                        Verify impressions in your analytics or ad platform.
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <strong>{`Example of Tag 159545`}</strong>
                                <div className={"google-tag-manager-img"}>
                                    <img src={siteVisitorTagImg} alt="siteTag" style={{maxWidth:"100%"}} />
                                </div>

                            </div>
                        </TabStripTab>}
                </TabStrip>

                {/*</div>*/}

                <DialogActionsBar>
                    <div className={"idx-pixel-dialog-button-container"}>
                        <Button
                            className={"button-standard button-white"}
                            type={'button'}
                            disabled={false}
                            onClick={() => {
                                closePixelDialog();
                            }}
                        >
                            Ok
                        </Button>
                    </div>
                </DialogActionsBar>

            </Dialog>

        </div>
    )
}
export default IdxTagInstructions;